import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

/**
 * Route for the new Operations Reports experience.
 *
 * Path params:
 *   :spaceId? - Optional. Identifies the space/team scope for the reports page.
 *   :tabId?   - Optional. Identifies the active tab within the reports page.
 *
 * Both params are optional so the sidebar link /jira/ops/reports-new works
 * without params; the app resolves defaults and replaces the URL accordingly.
 *
 * Gated behind: platform_avp_jira_ops_reporting
 */
export const eocGlobalReportsNewRoute: InvariantJiraRoute = {
	name: 'eoc-global-reports-new',
	path: '/jira/ops/reports-new/:spaceId?/:tabId?',
	exact: true,
};
